import { OptionType } from './AttributesImport.types';

export const isCompositeOrStatistic = (attribute: OptionType) =>
  attribute.signalType === 'composite' || attribute.signalType === 'statistic';
